// extracted by mini-css-extract-plugin
export default {"MyFilters":"my-filters_MyFilters__TwFr4"};